import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
const API_URL = `${BASE_URL}/api/public`;

const api = axios.create({
  baseURL: API_URL
});

const PublicAPI = {
  get: (endpoint, config = {}) =>
    api.get(endpoint, config).then(response => response.data),
  post: (endpoint, data, config = {}) =>
    api.post(endpoint, data, config).then(response => response.data),

  put: (endpoint, data, config = {}) =>
    api.put(endpoint, data, config).then(response => response.data),

  delete: (endpoint, config = {}) =>
    api.delete(endpoint, config).then(response => response.data)
};

export default PublicAPI;